import { API, axios, SendRequest, toastr} from '@/imports-files/pages/admins/dashboard/clients/integration';


export class ClientIntegration extends SendRequest {
  // async getIntegrations(params, client_auth_cookies) {
  //   try {
  //     const result = await axios({
  //       method: 'get',
  //       url: API.admins.dashboard.clients.integration.CLIENT_INTEGRATIONS_URL,
  //       headers: {cookie: `Authorization=${client_auth_cookies}`},
  //       params: params,
  //     });

  //     return result.data;
  //   } catch (error) {
  //     return error;
  //   }
  // }

  async getIntegrations(params, client_id) 
  {
    const url = API.admins.dashboard.clients.integration.CLIENT_INTEGRATIONS_URL.replace('$client_id', client_id)
    try {
      const result = await axios.get( url,
          {
            params: params
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());

      return result;
    } catch (error) {
      return error;
    }
  }


  async addIntegrations(params, client_id) {
    const url = API.admins.dashboard.clients.integration.ADD_INTEGRATIONS_URL.replace('$client_id', client_id);
    try {
      const result = await axios.post( url,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());

      return result;
    } catch (error) {
      return error;
    }
  }

}
